var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCloseCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1123_7705)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-180 27 27)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6121 9.18742L16.4233 12.9987C16.5008 13.0761 16.5564 13.158 16.5901 13.2446C16.6238 13.3311 16.6406 13.4234 16.6406 13.5215C16.6406 13.6196 16.6238 13.7119 16.5901 13.7984C16.5564 13.8849 16.5008 13.9669 16.4233 14.0443L12.599 17.8687C12.4541 18.0135 12.2777 18.0859 12.0696 18.0859C11.8615 18.0859 11.685 18.0135 11.5402 17.8687C11.3953 17.7238 11.3251 17.5452 11.3295 17.3327C11.3339 17.1202 11.4085 16.9416 11.5533 16.7967L14.8286 13.5215L11.5402 10.2331C11.3953 10.0882 11.3229 9.91396 11.3229 9.71025C11.3229 9.50655 11.3953 9.33227 11.5402 9.18742C11.685 9.04258 11.8637 8.97016 12.0762 8.97016C12.2886 8.97016 12.4673 9.04258 12.6121 9.18742Z",
    fill: "#3772FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.4838,
    y: 26.4838,
    width: 25.9677,
    height: 25.9677,
    rx: 12.9838,
    transform: "rotate(-180 26.4838 26.4838)",
    stroke: "#3772FF",
    strokeWidth: 1.03233
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1123_7705"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-180 27 27)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCloseCollapseIcon);
export default __webpack_public_path__ + "static/media/blueCloseCollapseIcon.bfc56eea.svg";
export { ForwardRef as ReactComponent };